import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import React from 'react';

export interface MenuOptions {
  menuName: string;
  menuAction?: (index: number, event: React.MouseEvent<HTMLElement>) => void;
}

export interface MenuItemContainerProps {
  isMobile: boolean;
  menuOptions: MenuOptions[];
  activeIndex: number;
}

const MenuItemContainer = ({ isMobile, menuOptions, activeIndex }: MenuItemContainerProps) => {
  const theme = useTheme();

  return (
    <React.Fragment>
      {menuOptions.map((item: MenuOptions, index: number) => (
        <MenuItem
          key={index}
          sx={{
            fontSize: '20px',
            marginTop: !isMobile ? '20px' : index !== 0 ? '20px' : '0px',
            fontWeight: 500,
            background: '#1A1A1A',
            color: theme?.palette?.text?.primary,
            opacity: index === activeIndex ? 0.5 : 1,
            fontFamily: theme?.MojitoClaim?.font?.secondary
          }}
          onClick={(e) => item?.menuAction?.(index, e)}
        >
          {item?.menuName}
        </MenuItem>
      ))}
    </React.Fragment>
  );
};

export default MenuItemContainer;
